import CommonImage from "@/components/common/image/CommonImage";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import Image from "next/image";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import dynamic from "next/dynamic";

const Drawer = dynamic(() => import("antd/es/drawer"), { ssr: false });
import SearchBarMobile from "./../search/SearchBarMobile";
import { setUser } from "@/redux/slices/userSlice";
import { F_TOKEN_STORE_KEY } from "@/constants/storage";
import Cookies from "js-cookie";

export default function AuthMenuDrawer({
  isMenuOpen,
  setIsMenuOpen,
  userInfo,
}) {
  const pathname = usePathname();
  const setting = useSelector((state) => state.setting.data);
  const router = useRouter();

  const dispatch = useDispatch();

  const handleLogout = async () => {
    try {
      setIsMenuOpen(false);
      await fetch("/api/logout", { method: "GET" });
      dispatch(setUser(null));
      Cookies.remove(F_TOKEN_STORE_KEY);
      router.push("/login");
      router.refresh();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const menu = [
    {
      icon: "/images/admission-icon/home-icon.png",
      label: "হোম",
      link: "/",
    },

    ...(userInfo
      ? [
          {
            icon: "/images/dashboard-images/dashboard.avif",
            label: "ড্যাশবোর্ড",
            selected: true,
            link: "/student/dashboard",
          },
          {
            icon: "/images/dashboard-images/profile.avif",
            label: "প্রোফাইল",
            link: "/student/profile",
          },
          {
            icon: "/images/dashboard-images/online-course.avif",
            label: "আমার কোর্স",
            link: "/student/my-courses",
          },

          {
            icon: "/images/dashboard-images/calender.avif",
            label: "ক্লাস ক্যালেন্ডার",
            link: "/student/calender",
          },
          {
            icon: "/images/dashboard-images/result.avif",
            label: "রেজাল্ট",
            link: "/student/result",
          },
          {
            icon: "/images/dashboard-images/online-course.avif",
            label: "আমার রিপোর্ট কার্ড",
            link: "/student/report-card",
          },
          {
            icon: "/images/dashboard-images/faq.avif",
            label: "Q&A (চ্যাট বেসড)",
            link: "/student/inbox",
          },
          {
            icon: "/images/dashboard-images/notebook.png",
            label: "পূর্ববর্তী প্র্যাকটিস এক্সাম",
            link: "/student/previous-exam-practice",
          },
          {
            icon: "/images/dashboard-images/problem-solving.png",
            label: "মিসড পরীক্ষা",
            link: "/student/missed-exam",
          },
          {
            icon: "/images/dashboard-images/data.png",
            label: "মিসড ক্লাস",
            link: "/student/missed-class",
          },
          {
            icon: "/images/dashboard-images/ranking.avif",
            label: "লিডারবোর্ড",
            link: "/student/leaderboard",
          },

          {
            icon: "/images/dashboard-images/payment-history.avif",
            label: "পেমেন্ট হিস্টোরি ও ইনভয়েস ডাউনলোড",
            link: "/student/payment-history",
          },
          {
            icon: "/images/dashboard-images/password-change.avif",
            label: "পাসওয়ার্ড পরিবর্তন",
            link: "/student/password-change",
          },
        ]
      : []),

    {
      label: "সকল কোর্স",
      link: "/courses/all",
      icon: "/images/admission-icon/book-icon.png",
    },
    {
      label: "ফ্রি এক্সাম",
      link: "/student/free-exam",
      icon: "/images/admission-icon/free-exam.png",
    },
    {
      label: "শাখাসমূহ",
      link: "/branches",
      icon: "/images/admission-icon/branches.png",
    },
    ...(userInfo
      ? [
          {
            icon: "/images/admission-icon/logout.png",
            label: "লগআউট",
            onClick: handleLogout,
          },
        ]
      : [
          {
            icon: "/images/admission-icon/log_in.png",
            label: "লগইন",
            link: "/login",
          },
        ]),
  ];

  return (
    <Drawer
      open={isMenuOpen}
      onClose={() => setIsMenuOpen(false)}
      placement="left"
      height="auto"
      maskClosable
      destroyOnClose
      styles={{
        header: { display: "none" },
      }}
      closable={false}
      className="mobile-sidebar !bg-fill-white !w-[290px]"
    >
      {/* Drawer Header */}
      <div className="bar-header">
        <a herf="#" className="img-wrap leading-0">
          <CommonImage
            src={
              setting?.logo_light_url ??
              "/images/header-footer/main_logo_light.avif"
            }
            alt="Icon"
            className="icon-img [.dark_&]:hidden inline-block"
          />
          <CommonImage
            src={
              setting?.logo_dark_url ??
              "/images/header-footer/main_logo_light.avif"
            }
            alt="Icon"
            className="icon-img hidden [.dark_&]:inline-block"
          />
        </a>
        <button onClick={() => setIsMenuOpen(false)} className="close-icon">
          ✕
        </button>
      </div>

      {/* Drawer Content */}
      <div className="sidebar-content">
        {/* profile-part */}
        <div className="profile-part-wrap">
          {/* <div className="student-header-wrap bg-pattern">
            <div className="student-image-wrap">
              <Image
                src={
                  userInfo?.student?.profile_url ??
                  "/images/dashboard-images/student-profile.avif"
                }
                className="student-image"
                alt={"Profile"}
                width={250}
                height={250}
              />
            </div>
            <div className="Student-identity ">
              <h2 className="name">{userInfo?.name}</h2>
              <div className="identy-data">
                <p className="data">
                  <span className="text-width">ক্লাসঃ</span>{" "}
                  {userInfo?.student?.class?.title}
                </p>
                <p className="data">
                  <span className="text-width">বিভাগঃ</span>{" "}
                  {userInfo?.student?.group?.name}
                </p>
                <p className="data">
                  <span className="text-width">পরীক্ষাঃ</span> এস এস সি
                </p>
              </div>
            </div>
          </div> */}
          {/* List */}
          <SearchBarMobile />

          <div className="flex flex-col gap-6">
            <div className="student-dashboard-list">
              {menu.map((item, i) => {
                const isActive = pathname === item.link;

                return item.onClick ? (
                  <button key={i} onClick={item.onClick} className="list-item">
                    <CommonImage
                      src={item.icon}
                      className="student-image"
                      alt={item.label}
                    />
                    <span>{item.label}</span>
                  </button>
                ) : (
                  <Link
                    key={i}
                    href={item.link}
                    className={`list-item ${isActive ? "selected" : ""}`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <CommonImage
                      src={item.icon}
                      className="student-image"
                      alt={item.label}
                    />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
